import { apiClient } from './client'

export interface TimedRequest {
  id: string
  user_id: string
  user_name?: string | null
  user_avatar_url?: string | null
  kind: 'checkin' | 'checkout' | 'checkout_correction' | 'late_checkout'
  date: string
  requested_time: string
  wfh: boolean
  reason?: string | null
  source?: string | null
  status: string
  review_note?: string | null
  reviewed_at?: string | null
  reviewer_name?: string | null
  created_at: string
}

export async function listPendingApprovals(): Promise<TimedRequest[]> {
  const res = await apiClient.get<{ items: TimedRequest[] }>('/attendance-approvals/pending')
  return res.data.items
}

export async function listMyApprovals(): Promise<TimedRequest[]> {
  const res = await apiClient.get<{ items: TimedRequest[] }>('/attendance-approvals/mine')
  return res.data.items
}

export async function reviewApproval(
  id: string,
  data: { status: 'approved' | 'rejected'; review_note?: string },
): Promise<TimedRequest> {
  const res = await apiClient.post<TimedRequest>(`/attendance-approvals/${id}/review`, data)
  return res.data
}
